
import React, {useEffect} from "react";
import {Box, Typography, TextField, Button, MenuItem, FormControlLabel, Checkbox} from "@mui/material";
import {use} from "i18next";
import useCartData from "../../../hooks/cart/useCartData";

const FIELD_WIDTH = 286;


function AddressTextField({ name, label, formik, required = false, ...props }) {
    return (
        <Box sx={{ position: "relative", width: "100%", height: 59 }}>
            <TextField
                {...formik.getFieldProps(name)}
                {...props}
                required={required}
                fullWidth
                focused={true}
                label={label}
                variant="outlined"
                size="small"
                InputLabelProps={{
                    sx: {
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontSize: 14,
                        color: "#111111",
                        "&.Mui-focused": {
                            color: "#111111",
                        },
                    },
                }}
                InputProps={{
                    sx: {
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontSize: 14,
                        "& .MuiInputBase-input": {
                            py: 1.1,
                            pl: 1,
                        },
                        "& fieldset": {
                            borderColor: "#111111",
                            borderWidth: 1,
                            borderRadius: "4px",
                        },
                        "&:hover fieldset": {
                            borderColor: "#111111",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "#111111",
                        },
                    },
                }}
            />
        </Box>
    );
}


function AddressSelectField({
                                label,
                                value,
                                onChange,
                                options,
                                name,
                                error,
                                helperText,
                            }) {
    return (
        <Box sx={{ position: "relative", width: "100%", height: 59 }}>
            <TextField
                select
                name={name}
                value={value}
                onChange={onChange}
                error={error}
                helperText={helperText}
                focused={true}
                variant="outlined"
                size="small"
                fullWidth
                label={label}
                InputLabelProps={{
                    sx: {
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontSize: 16,
                        color: "#111111",
                        "&.Mui-focused": {
                            color: "#111111",
                        },
                    },
                }}
                InputProps={{
                    sx: {
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontSize: 16,
                        "& .MuiInputBase-input": {
                            py: 1.1,
                            pl: 1,
                        },
                        "& fieldset": {
                            borderColor: "#111111",
                            borderWidth: 1,
                            borderRadius: "4px",
                        },
                        "&:hover fieldset": {
                            borderColor: "#111111",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "#111111",
                        },
                    },
                }}
            >
                {options.map((opt) => (
                    <MenuItem key={opt.id}  value={String(opt.id)}>
                        {opt.Description}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
}

export default function AddressForm({ formik, isEdit, countryOptions ,t}) {


    const fieldError = (name) =>
        Boolean(formik.touched[name] && formik.errors[name]);

    const fieldHelperText = (name) =>
        formik.touched[name] && formik.errors[name]
            ? formik.errors[name]
            : "";
    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{ maxWidth: 605, width: "100%" }}
        >

            <Typography
                sx={{
                    fontFamily: "'Roboto Condensed', sans-serif",
                    fontSize: 14,
                    mb: 3,
                    color: "#111111",
                }}
            >
                {t("addressFormInstruction", {
                    action: isEdit ? t("editAddressAction") : t("addAddressAction"),
                })}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "flex-start",
                    gap: { xs: 2.5, md: 4 },
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        width: { xs: "100%", md: FIELD_WIDTH },
                        flexShrink: 0,
                    }}
                >
                    <AddressTextField
                        name="Address"
                        label={t("Address")}
                        formik={formik}
                        required
                    />
                    <AddressTextField
                        name="ZipCode"
                        label={t("Zip Code")}
                        formik={formik}
                    />
                    <AddressTextField
                        name="Region"
                        label={t("Region")}
                        formik={formik}
                    />
                </Box>


                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        width: { xs: "100%", md: FIELD_WIDTH },
                        flexShrink: 0,
                    }}
                >
                    <AddressSelectField
                        name="CountryId"
                        label={t("Country")}
                        formik={formik}
                        options={countryOptions}
                        value={formik.values.CountryId}
                        onChange={formik.handleChange}
                        error={fieldError("CountryId")}
                        helperText={fieldHelperText("CountryId")}
                    />
                    <AddressTextField
                        name="AddrPhone"
                        label={t("Address Phone")}
                        formik={formik}
                    />
                    <AddressTextField
                        name="City"
                        label={t("City")}
                        formik={formik}
                    />
                </Box>
            </Box>

            {/*<Typography*/}
            {/*    sx={{*/}
            {/*        fontFamily: "'Roboto Condensed', sans-serif",*/}
            {/*        fontSize: 12,*/}
            {/*        mt: 3,*/}
            {/*        mb: 1,*/}
            {/*        color: "#111111",*/}
            {/*    }}*/}
            {/*>*/}
            {/*    ** Θα πρέπει να εισάγετε έναν τουλάχιστον αριθμό επικοινωνίας*/}
            {/*</Typography>*/}

            {/*<Box sx={{ maxWidth: FIELD_WIDTH * 2 + 32, width: "100%" }}>*/}
            {/*    <AddressTextField name="email" label="Email" formik={formik} />*/}
            {/*</Box>*/}

            <Box sx={{ mt: 3, maxWidth: FIELD_WIDTH * 2 + 32, width: "100%" }}>
                <TextField
                    multiline
                    minRows={3}
                    focused={true}
                    fullWidth
                    variant="outlined"
                    {...formik.getFieldProps("Comments")}
                    label={t("Additional Information")}
                    InputLabelProps={{
                        sx: {
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontSize: 14,
                            color: "#111111",
                            "&.Mui-focused": {
                                color: "#111111",
                            },
                        },
                    }}
                    InputProps={{
                        sx: {
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontSize: 14,
                            "& fieldset": {
                                borderColor: "#111111",
                                borderWidth: 1,
                                borderRadius: "5px",
                            },
                            "&:hover fieldset": {
                                borderColor: "#111111",
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#111111",
                            },
                        },
                    }}
                />
            </Box>
            <Box sx={{ mt: 2 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="isInvoice"
                            checked={String(formik.values.isInvoice) === "1"}
                            onChange={(e) =>
                                formik.setFieldValue("isInvoice", e.target.checked ? "1" : "0")
                            }
                        />
                    }
                    label={t("Invoice address")}
                />
            </Box>
            <Box sx={{ mt: 3 }}>
                <Button
                    type="submit"
                    sx={{
                        px: 4,
                        py: 1,
                        borderRadius: "80px",
                        backgroundColor: "#E5007E",
                        border: "1px solid #E5007E",
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontWeight: 900,
                        fontSize: 12,
                        textTransform: "uppercase",
                        color: "#FCFCFC",
                        "&:hover": {
                            backgroundColor: "#c9006b",
                        },
                    }}
                >
                    {isEdit ? t("Save changes") : t("Save")}
                </Button>
            </Box>
        </Box>
    );
}
